import { Component } from '@angular/core';

@Component({
  selector: 'vpfa-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
})
export class EmptyComponent {}
